import React from 'react';
import { IOldIconProps } from './type';

const QuestionOutline: React.FC<IOldIconProps> = ({
  color = '#000',
  width,
  height,
  ...props
}) => {
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="black"
      />
      <path
        d="M10.632 15.144V14.838C10.632 14.418 10.674 14.058 10.758 13.758C10.854 13.446 11.028 13.128 11.28 12.804C11.532 12.468 11.892 12.072 12.36 11.616C12.684 11.292 12.936 10.998 13.116 10.734C13.308 10.458 13.404 10.128 13.404 9.744C13.404 9.252 13.272 8.88 13.008 8.628C12.756 8.364 12.384 8.232 11.892 8.232C11.328 8.232 10.896 8.37 10.596 8.646C10.308 8.922 10.098 9.36 9.966 9.96L7.5 9.69C7.644 8.61 8.082 7.728 8.814 7.044C9.546 6.348 10.614 6 12.018 6C13.338 6 14.352 6.306 15.06 6.918C15.768 7.53 16.122 8.34 16.122 9.348C16.122 10.008 15.978 10.584 15.69 11.076C15.414 11.568 15.024 12.042 14.52 12.498C14.124 12.858 13.818 13.17 13.602 13.434C13.398 13.686 13.254 13.932 13.17 14.172C13.098 14.4 13.062 14.658 13.062 14.946V15.144H10.632ZM13.134 16.386V19.068H10.542V16.386H13.134Z"
        fill={color}
      />
    </svg>
  );
};

export default QuestionOutline;
